import styled from 'styled-components';

import { CheckboxCheckedIcon, CheckboxDefaultIcon } from 'static';

export const StyledSelectAllButton = styled.button`
  width: 14px;
  height: 14px;
  border: none;
  outline: none;
  background-repeat: no-repeat;
  background-image: ${({ checked }) =>
    `url(${checked ? CheckboxCheckedIcon : CheckboxDefaultIcon})`};
`;

export const StyledHeader = styled.div`
  min-height: 30px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  background-color: transparent;
  font-weight: normal;
  border-bottom: 1px solid ${({ theme }) => theme.color.porcelain};
`;

export const StyledHeaderLabel = styled.span`
  margin-left: 11px;
  font-size: 12px;
  color: ${({ theme }) => theme.color.baliHai};
`;

export const StyledListWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledListItem = styled.div`
  height: 61px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  border-bottom: ${({ theme }) => `1px solid ${theme.color.porcelain}`};
  font-weight: 400;
  font-size: 15px;
`;

export const StyledNameWrapper = styled.div`
  width: 290px;
`;

export const ScrollWrapper = styled.div`
  overflow-y: auto;
  height: calc(100svh - 306px);
  overflow-x: hidden;
`;

export const StyledSearchWrapper = styled.div`
  padding: 13px 16px 14px 15px;
`;
